module.exports = __webpack_public_path__ + "static/media/gy.8993c26d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gy.svg
// module id = 139
// module chunks = 0